const es_ES = {
  restartInterviewButton: "Empezar de nuevo",
  restartInterviewConfirmTitle: "¿Empezar una nueva entrevista?",
  restartInterviewConfirmDescription: "Se iniciará una nueva entrevista desde el principio. Los registros de las entrevistas anteriores se conservarán.",
  restartInterviewCancel: "Cancelar",
  restartInterviewFailed: "No se pudo reiniciar la entrevista. Inténtalo de nuevo más tarde.",
  restartInterviewLimitReached: "Se ha alcanzado el límite de entrevistas. No puedes iniciar otra.",
  restartInterviewClosed: "Esta entrevista está cerrada. No puedes iniciar otra.",
  restartInterviewCutoff: "El plazo de la entrevista ha vencido. No puedes iniciar otra.",
  interviewLoading: "Cargando la entrevista…",
  interviewLinkInvalid: "Enlace de entrevista no válido",
  interviewLoadFailed: "No se pudo cargar la entrevista. Inténtalo de nuevo más tarde.",
  interviewRetry: "Reintentar",
  saveInfoFailed: 'No se pudo guardar tu información. Inténtalo de nuevo.',
  loadLatestInterviewFailed: 'No se pudo cargar el registro más reciente de la entrevista. Inténtalo de nuevo más tarde.',
  interviewProgressSaved: 'No se perderá el progreso de la entrevista',
  previousStimulus: 'Concepto anterior',
  nextStimulus: 'Concepto siguiente',
  expandStimulus: 'Ampliar concepto',
  closeStimulusPreview: 'Cerrar vista previa del concepto',
  stimulusPreview: 'Vista previa del concepto',
  imageTooLarge: 'La imagen no puede superar los 10 MB',
  imageFormatJpegPngOnly: 'Solo se admiten imágenes PNG, JPEG y JPG',
  imageFilesOnly: 'Solo se pueden subir archivos de imagen',
  imageUploadFailed: 'No se pudo subir la imagen. Inténtalo de nuevo.',
  finalUploadFailed: 'No se pudieron subir los archivos. Inténtalo de nuevo.',
  TitleTop: '¡ESTÁS INVITADO!',
  HeardVoice: 'HAZ OÍR TU VOZ Y RECIBE UNA RECOMPENSA',
  Sophie: 'Charla informal de 5 a 10 minutos con Ava',
  Sponsored: 'Patrocinado por Papá Noel🎅',
  Chikkens: 'Inicia una charla breve y recibe una recompensa',
  Dollars: 'con tu CHIMOJI único',
  Congrats: '¡ENHORABUENA!',
  Welcome: 'Bienvenido ',
  StartInterview: 'Comienza la entrevista',
  Submit: 'Presentación',
  Stoprecording: 'Deje de responder',
  Aiinterviewer: 'Entrevistador',
  AiModeratedInterview: 'ENTREVISTA MODERADA POR IA',
  TalkToAva: 'Hablar con Ava',
  microphoneAccessTitle: 'Permitir acceso al micrófono',
  microphoneAccessDescription: 'Ava necesita tu micrófono para tener una conversación de voz natural.',
  microphoneAllow: 'Permitir micrófono',
  microphoneNotNow: 'Ahora no',
  microphoneConnectedTitle: 'Micrófono conectado',
  microphoneConnectedDescription: 'Todo listo. Ava está preparada para escucharte.',
  microphoneDeniedTitle: 'Se necesita acceso al micrófono',
  microphoneDeniedDescription: 'Permite el acceso al micrófono en la configuración del navegador y vuelve a intentarlo.',
  microphoneTryAgain: 'Intentar de nuevo',
  VoiceAnswer: 'Respuesta de voz',
  TextAnswer: 'Respuesta de texto',
  StudyMainTitle: 'Antes de la entrevista real, haremos una selección',
  StudyMainTip:
    'Desafortunadamente, usted no es el grupo objetivo de esta entrevista y no puede participar en esta entrevista',
  ThankYou: 'Gracias',
  Refresh: 'Actualizar la página no perderá el progreso de este chat',
  Carousel:
    'Puede producirse una ligera latencia debido a las condiciones de Internet',
  CheckOut: '¿Quieres crear entrevistas como esta también? Échale un vistazo ',
  Rewarded:
    'Si desea recibir una recompensa, el entrevistador debe tener información sobre usted ',
  InterviewerReward: 'Esta es la recompensa de tu entrevistador ',
  Register: 'Registrarse/iniciar sesión como',
  Insighteer: 'INSIGHTEER',
  Reward: 'Obtenga recompensas exclusivas',
  CreatePassword: 'Crea una contraseña para completar el registro',
  Becoming: '¡Se parte de nosotros!',
  Password: '¡Por favor introduzca su contraseña!',
  ChooseTopic: 'Elige un tema que te interese',
  Identity: '你是...',
  Awesome: 'Awesome!',
  Rocks: 'ROCKS',
  Followus: 'Síganos',
  Unique:
    'Este CHIMOJI único que le pertenece se registrará en la cadena de bloques junto con esta entrevista',
  Next: 'Siguiente paso',
  ViewRewards: 'Ver recompensas',
  endMeg1:
    'Por favor deja tu email aquí para que podamos enviarte la reproducción de voz',
  endMeg2:
    'Por favor deja tu información aquí para recibir incentivos del creador de esta entrevista.',
  endMeg3:
    'Por favor deja tu información aquí para el creador de esta entrevista.',
  endMsg5: 'Por favor deja tu información aquí para obtener la ',
  endMsg6: 'resultado de su prueba MBTI',
  Done: 'entregar',
  Done1: 'entregar',
  GetIncentives: 'OBTENGA INCENTIVOS',
  GetStartedFreeNow: 'Empieza gratis ahora',
  UniqueChimojiNFT: 'Chimoji NFT único',
  endMsg4: '¿Quieres crear tu propia entrevista?',
  ResumeInterview: 'Haga clic para reanudar la entrevista',
  interviewPausedTitle: 'Entrevista pausada',
  interviewPausedDescription: 'Tu progreso se ha guardado. Puedes continuar cuando estés listo.',
  resumeInterviewButton: 'Reanudar entrevista',
  pauseInterview: 'Pausar',
  pauseInterviewConfirmTitle: '¿Pausar la entrevista?',
  pauseInterviewConfirmContent:
    'Tu progreso se guardará y podrás reanudar la entrevista más tarde.',
  pauseInterviewConfirmOk: 'Pausar',
  pauseInterviewConfirmCancel: 'Continuar la entrevista',
  poorConnection: 'Mala conexión',
  connectionReconnectingTitle: 'Reconectando…',
  connectionReconnectingDescription: 'Mantén esta página abierta. Ava está recuperando la conexión.',
  connectionReconnectedTitle: 'Reconectado',
  connectionReconnectedDescription: 'La conexión se ha recuperado. Continuamos la entrevista.',
  connectionDisconnectedTitle: 'Conexión perdida',
  connectionDisconnectedDescription: 'El progreso de tu entrevista se ha guardado.',
  refresh: 'Actualizar la página no perderá el progreso.',
  voiceSnapshot: 'Captura de voz',
  fromInterview: 'De mi entrevista con Ava, curadora de historias de IA',
  findMore: 'Descubre más en Chikka.ai',
  msg1: 'PRUEBA TU MBTI EN 5 MINUTOS HABLANDO CON AVA',
  speaking: 'Estás hablando...',
  avaSpeaking: 'Ava está hablando...',
  avaListening: 'Ava está escuchando...',
  stimuliConversationWithAva: 'Estas en una conversacion con Ava',
  stimuliReviewConcepts:
    'Revisa cuidadosamente los conceptos a continuacion y responde las preguntas de Ava.',
  stimuliSwipeInstruction:
    'Desliza a izquierda o derecha para ver todos los conceptos.',
  stimuliFullscreenInstruction: 'Haz doble clic en una imagen para verla a pantalla completa.',
  finalUploadTitleFallback: 'Sube archivos',
  finalUploadInstructionFallback:
    'Agrega archivos antes de terminar la entrevista',
  finalUploadTap: 'Toca para subir',
  finalUploadHelp:
    'Tu archivo nos ayuda a comprender mejor tu experiencia.',
  finalUploadLimit: 'Maximo 10 archivos',
  finalUploadSubmit: 'ENVIAR',
  finalUploadSkip: 'Omitir',
  finalUploadWait: 'Espera a que todos los archivos terminen de subir',
}
export default es_ES
